import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ComponentBuilder from '../../archetypes/ComponentBuilder'
import Interaction from '../Interaction'

class LearningAssessment extends Component {
  render () {
    let {item, responseState, onQuestionRender, readonly} = this.props
    return (
      <section>
        { this.rawMarkup(item.content[0].intro) }
        {
          // TODO: Should content actually be an array?
          item.content[0].interactions.map(interaction => {
            return (
              <Interaction key={interaction.id} item={interaction} responseState={responseState} onQuestionRender={onQuestionRender} readonly={readonly} />
            )
          })
        }
      </section>
    )
  }

  rawMarkup (markup) {
    if (markup) {
      const componentBuilder = new ComponentBuilder({
        componentMap: [{
          when: (node) => { return node && (node.tagName || '').toLowerCase() === 'img' && (node.getAttribute('class') || '').toLowerCase().indexOf('hwicontitle') !== -1 },
          ignore: true
        }]
      })
      return componentBuilder.build(`<div>${markup}</div>`)
    }
    return null
  }
}

LearningAssessment.propTypes = {
  responseState: PropTypes.object,
  item: PropTypes.shape({
    type: PropTypes.oneOf(['hwDecisionAssessment'])
  }).isRequired,
  onQuestionRender: PropTypes.func,
  readonly: PropTypes.bool
}

export default LearningAssessment



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/LearningAssessment/index.js